import axios from "axios";

// Use explicit env var, or fall back to same origin (works for both IP and domain)
const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  // In production build served from same server, use window.location.origin
  if (typeof window !== "undefined" && window.location.hostname !== "localhost") {
    return window.location.origin;
  }
  return "http://localhost:5000";
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      // Check expiry before sending
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) {
          localStorage.removeItem("token");
          window.location.href = "/mudugudu";
          return Promise.reject(new Error("Token yarangiye igihe"));
        }
      } catch { /* ignore malformed token */ }
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const path = window.location.pathname;
      const isSubRequest = url.includes('/signatures') || url.includes('/sign-receiver') || url.includes('/sign-report');
      const isAdminPage = path.includes('/regsup') || path.includes('/codeadd');
      const isAdminDataRequest = url.includes('/get_akagari') || url.includes('/get_mudugudu') || url.includes('/get_abandi') || url.includes('/password/update') || url.includes('/leaders/update');
      if (!isSubRequest && !isAdminPage && !isAdminDataRequest) {
        localStorage.removeItem("token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("sup_id");
        localStorage.removeItem("role");
        localStorage.removeItem("fullname");
        const role = localStorage.getItem("role") || '';
        if (path.startsWith("/dashboard/Akagari")) window.location.href = "/akagari";
        else if (path.startsWith("/dashboard/Isibo") || path.startsWith("/dashboard/Umunyamabanga")) window.location.href = "/abandi";
        else if (path.startsWith("/dashboard/Mudugudu") || path.startsWith("/view-report")) window.location.href = "/mudugudu";
        else window.location.href = "/mudugudu";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;